import { render, staticRenderFns } from "./qtdSales.vue?vue&type=template&id=24fd7698&scoped=true&"
import script from "./qtdSales.vue?vue&type=script&lang=ts&"
export * from "./qtdSales.vue?vue&type=script&lang=ts&"
import style0 from "./qtdSales.vue?vue&type=style&index=0&id=24fd7698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd7698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardTitle,VCarousel,VCarouselItem,VCol,VRow,VSheet})
